import {
  GET_TRAER_VIDEOS,
  GET_TRAER_VIDEOS_FAIL,
  GET_TRAER_VIDEOS_LIMPIAR,
  GET_TRAER_VIDEOS_SUCCESS,
  RESET_PORTAL_CONTEXT,
} from "../ActionTypes";
import { initialStateCardVideoTutoriales } from "../initialStates/cardVideoTutoriales";

const cardVideoTutoriales = (state, { payload, type }) => {
  switch (type) {
    case GET_TRAER_VIDEOS:
      return {
        ...state,
        cardVideoTutoriales: {
          loading: true,
          error: false,
          data: false,
        },
      };
    case GET_TRAER_VIDEOS_SUCCESS:
      return {
        ...state,
        cardVideoTutoriales: {
          loading: false,
          data: payload.data,
          error: false,
        },
      };
    case GET_TRAER_VIDEOS_FAIL:
      return {
        ...state,
        cardVideoTutoriales: {
          loading: false,
          data: false,
          error: true,
        },
      };
    case GET_TRAER_VIDEOS_LIMPIAR:
      return {
        cardVideoTutoriales: {
          loading: false,
          error: false,
          data: false,
        },
      };
    case RESET_PORTAL_CONTEXT:
      return initialStateCardVideoTutoriales;
    default:
      break;
  }
};

export default cardVideoTutoriales;
